import {ChangeDetectionStrategy, Component, OnInit, ViewChild} from '@angular/core';
import {FormGroup, ValidatorFn, Validators}                    from '@angular/forms';
import {LoginStore}                                            from '../../stores/login/login.store';
import {PasswordStore}                                         from '../../stores/login/password.store';
import {RouterStore}                                           from '../../stores/router/router.store';
import {ApDynformsComponent}                                   from '../../ap-dynforms/ap-dynforms.component';
import {ApDynformsValidator}                                   from '../../ap-dynforms/ap-dynforms-validator';
import {
  ApDynformsConfigFieldset
}                                                              from '../../ap-dynforms/config/ap-dynforms-config-fieldset';
import {
  ApDynformsConfigTextbox, ApDynformsConfigTextboxType
} from '../../ap-dynforms/config/ap-dynforms-config-textbox';
import {
  ApDynformsPasswordStrength
}                                                              from '../../ap-dynforms/config/ap-dynforms-password-strength';
import {BehaviorSubject}                                       from 'rxjs';

/**
 * Component for the password recovery
 */
@Component({
  selector: 'ap-password-recovery',
  templateUrl: 'ap-password-recovery.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ApPasswordRecoveryComponent implements OnInit {
  constructor(private loginStore: LoginStore,
              private routerStore: RouterStore,
              private passwordStore: PasswordStore) {
  }

  @ViewChild(ApDynformsComponent, {static: true}) dynForm: ApDynformsComponent;
  public formValidators: ApDynformsValidator<ValidatorFn>[] = [
    new ApDynformsValidator({
      validator: this.pwdMatch,
      errorKey: 'PwRecover_ValidationInfoNotSamePasswords'
    }),
  ];
  public formConfig: ApDynformsConfigFieldset[] = [];

  private _pwdInput = new BehaviorSubject<string>('');

  /**
   * when the component is loaded
   */
  ngOnInit(): void {
    this.formBuilder();
    this.dynForm.initialized.subscribe(() => {
      this.dynForm.form.get('Password')?.valueChanges.subscribe(v => this._pwdInput.next(v));
    });
  }

  /**
   * binding of validators
   */
  formBuilder(): void {
    this.formConfig = [
      new ApDynformsConfigFieldset({
        key: 'passwordRecover_fieldset',
        legend: 'Admin_Pages_Password_New_Password',
        label: 'Admin_Pages_Password_New_Password_Tip',
        columns: 1,
        asyncTranslation: true,
        config: [
          new ApDynformsConfigTextbox({
            key: 'ActivationCode',
            label: 'PwRequest_EmailActivationKey',
            autocomplete: 'new-password',
            validators: [
              new ApDynformsValidator({
                validator: Validators.compose([Validators.required, Validators.minLength(5), Validators.maxLength(5)]),
                errorKey: 'PwRecover_ValidationInfoEmptyActivationKey',
              }),
            ],
          }),
          new ApDynformsConfigTextbox({
            key: 'Password',
            type: ApDynformsConfigTextboxType.Password,
            autocomplete: 'new-password',
            label: 'PwRecover_NewPassword',
            formErrors: ['PwRecover_ValidationInfoNotSamePasswords'],
            validators: [
              new ApDynformsValidator({
                validator: Validators.compose([Validators.required, Validators.minLength(0)]),
                errorKey: 'PwRecover_ValidationInfoEmptyNewPassword',
              }),
            ],
          }),
          new ApDynformsConfigTextbox({
            key: 'PasswordRepeat',
            type: ApDynformsConfigTextboxType.Password,
            autocomplete: 'new-password',
            label: 'PwRecover_NewPasswordValidation',
            formErrors: ['PwRecover_ValidationInfoNotSamePasswords'],
            validators: [
              new ApDynformsValidator({
                validator: Validators.compose([Validators.required, Validators.minLength(0)]),
                errorKey: 'PwRecover_ValidationInfoEmptyNewPassword',
              }),
            ],
          }),
          new ApDynformsPasswordStrength({
            key: 'PasswordStrength',
            label$: new BehaviorSubject<string>(''),
            value$: this._pwdInput,
          }),
        ],
      }),
    ];
  }

  public onSubmitClick(): void {
    this.passwordStore.setPassword(this.dynForm.form.value.ActivationCode, this.dynForm.form.value.Password);
  }

  private pwdMatch(frm: FormGroup): { mismatch: boolean } | null {
    const same = frm.get('Password')?.value === frm.get('PasswordRepeat')?.value;
    ApDynformsComponent.setErrorOnControl(frm.get('Password'), 'Invitations__Msg_Vali_Mismatch_Password_Repeat_Password', !same);
    ApDynformsComponent.setErrorOnControl(frm.get('PasswordRepeat'), 'Invitations__Msg_Vali_Mismatch_Password_Repeat_Password', !same);
    return same ? null : {mismatch: true};
  }
}
